const theme = {
    colors: {
        primary: '#ef9018', // naranja
        primaryLight: '#F7F7F7', // un tono de gris claro
        secondary: '#232F3E', // un tono de azul oscuro
        tertiary: '#FFFFFF', // blanco
        success: '#008000', // verde oscuro
        danger: '#FF0000', // rojo
        warning: '#FF9900', // naranja
        info: '#0066CC', // azul
        light: '#F7F7F7', // un tono de gris claro
        dark: '#232F3E', // un tono de azul oscuro
        lighterGrey: '#D3D3D3', // gris claro
        white: '#FFFFFF', // blanco
        lighterBlue: '#E6F0F3', // un tono de azul claro
        black: '#000000', // negro
    },
    fonts: {
        montserrat: 'Montserrat, sans-serif',
        poppins: 'Poppins, sans-serif',
        roboto: 'Roboto, sans-serif',
        amazon: "itc-officina-sans-std-bold', sans-serif",
        display: 'Montserrat, sans-serif',
        body: 'Noto Sans, sans-serif',
        diseñadora: 'Proxima Nova',
    },
    fontWeights: {
        light: '100',
        semiLight: '300',
        semiBold: '400',
        mediumSemiBold: '600',
        bold: '800',
    },
    fontSizes: {
        verysmall: '0.7rem',
        smallest: '1rem',
        small: '1.5rem',
        mediumSmall: '2rem',
        medium: '4rem',
        mediumBig: '5rem',
        big: '6rem',
        bigBig: '8rem',
    },
    spacing: {
        smallest: '1rem',
        small: '2rem',
        mediumSmall: '3rem',
        medium: '4rem',
        mediumBig: '5rem',
        big: '6rem',
    },
    height: {
        smallest: '1rem',
        small: '2rem',
        mediumSmall: '3rem',
        medium: '4rem',
        mediumBig: '5rem',
        big: '6rem',
        bigBig: '8rem',
    },
}

export default theme
